import React, { useState, useEffect } from 'react'
import Jornallistbyuser from './components/journalmanagement/jornallistbyuser'
import FetchApi from '../customhooks/functionFetchApi'
import Spinner from 'react-bootstrap/Spinner';
import { FaList, FaFileSignature, FaArchive, FaExclamationTriangle, FaCheck, FaSearch } from "react-icons/fa";


const Journalmanagement = () => {
  const FetchApis = new FetchApi();
  const [datajournal, setDatajournal] = useState([]);
  const [dataList, setDataList] = useState([])
  const [jourStatusAll, setJourStatusAll] = useState([]);
  const emcode = sessionStorage.getItem('EmCode');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadingdata();
    getJournalStatusAll();
  }, [])


  const loadingdata = () => {
    setLoading(true)
    setTimeout(() => {
      FetchApis.FethcGet(`/journal/getjournalByEmcode/${emcode}`).then((res) => {
        if (res) {
          setDatajournal(res.data.data);
          setDataList(res.data.data);
        }
        setLoading(false);
      })
    }, 1000);

  }

  function getJournalStatusAll() {
    FetchApis.FethcGet(`/journal/getJoranlstatusAll/${emcode}`).then((res) => {
      setJourStatusAll(res.data.data[0]);
    })
  }

  function heandleSearch(e) {
    const { value } = e.target;
    const filteredData = datajournal.filter((item) => {
      return Object.values(item).join('').toLowerCase().includes(value.toLowerCase())
    })
    setDataList(filteredData)
  }

  function filterSuccesfull() {
    setLoading(true)
    const filterData = datajournal.filter((item) => item.flowSuccesfull == '1');
    setDataList(filterData)
    setTimeout(() => setLoading(false), 1000);
  }

  function filterNotSuccesfull() {
    setLoading(true)
    const filterData = datajournal.filter((item) => item.flowSuccesfull == null);
    setDataList(filterData)
    setTimeout(() => setLoading(false), 1000);
  }

  function allListData() {
    setLoading(true)
    setDataList(datajournal)
    setTimeout(() => setLoading(false), 1000);
  }

  function cancelJournal() {
    setLoading(true)
    const filterData = datajournal.filter((item) => item.statusflow == "0000");
    setDataList(filterData)
    setTimeout(() => setLoading(false), 1000);
  }

  const cardStyle = {
    cursor: 'pointer',
    backgroundColor: 'rgba(255,255,255,0.15)',
    border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: 12,
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 140,
    transition: 'background 0.2s',
  };

  const iconBoxStyle = {
    backgroundColor: 'rgba(255,255,255,0.25)',
    borderRadius: 8,
    padding: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div style={{ backgroundColor: '#f4f6f8', minHeight: '100vh' }}>

      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #1a7f5a 0%, #28B463 100%)',
        padding: '16px 24px 20px',
        boxShadow: '0 3px 10px rgba(0,0,0,0.15)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ color: '#fff', fontSize: 22, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
              <FaFileSignature /> เอกสารทั้งหมดของผู้ใช้งาน
            </div>
            <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, marginTop: 3 }}>
              เอกสารทั้งหมด {datajournal.length} รายการ
            </div>
          </div>

          {/* Search */}
          <div style={{ position: 'relative', marginTop: 4 }}>
            <FaSearch style={{
              position: 'absolute', left: 11, top: '50%',
              transform: 'translateY(-50%)', color: '#aaa', fontSize: 13,
            }} />
            <input
              type='text'
              name='searchAlll'
              placeholder='ค้นหาข้อมูล...'
              onChange={(e) => heandleSearch(e)}
              style={{
                paddingLeft: 34, paddingRight: 14, paddingTop: 8, paddingBottom: 8,
                borderRadius: 20, border: 'none', fontSize: 13,
                outline: 'none', width: 230,
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                color: '#333',
              }}
            />
          </div>
        </div>

        {/* Stat Cards */}
        <div style={{ display: 'flex', gap: 12, marginTop: 16, flexWrap: 'wrap' }}>
          <div onClick={allListData} style={cardStyle}>
            <div style={iconBoxStyle}><FaList size={16} color="#fff" /></div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 11 }}>เอกสารทั้งหมด</div>
              <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>{jourStatusAll.journalall}</div>
            </div>
          </div>

          <div onClick={filterSuccesfull} style={cardStyle}>
            <div style={iconBoxStyle}><FaCheck size={16} color="#fff" /></div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 11 }}>อนุมัติแล้ว</div>
              <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>{jourStatusAll.approveall}</div>
            </div>
          </div>

          <div onClick={filterNotSuccesfull} style={cardStyle}>
            <div style={iconBoxStyle}><FaArchive size={16} color="#fff" /></div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 11 }}>รออนุมัติ</div>
              <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>{jourStatusAll.prendingall}</div>
            </div>
          </div>

          <div onClick={cancelJournal} style={cardStyle}>
            <div style={iconBoxStyle}><FaExclamationTriangle size={16} color="#fff" /></div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 11 }}>ยกเลิก</div>
              <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>{jourStatusAll.recallall}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div style={{ padding: '0 0' }}>
        {loading ? (
          <div style={{
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            padding: 60, gap: 14,
          }}>
            <Spinner animation="grow" variant="success" style={{ width: 48, height: 48 }} />
            <div style={{ color: '#6c757d', fontSize: 14 }}>กำลังโหลดข้อมูล...</div>
          </div>
        ) : (
          <Jornallistbyuser datatable={dataList} />
        )}
      </div>
    </div>
  )
}
export default Journalmanagement
